<nb-spinner class="nb-global-spinner" [status]="'primary'" [size]="'giant'"></nb-spinner>
<router-outlet></router-outlet>
<div *ngIf="show" class="ribbon">
  <p>{{message}}</p>
</div>
